import "./App.css";
import Navbar from "./Components/Navbar";
function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
